var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1667 9.5V17C11.1667 17.4583 10.7917 17.8333 10.3333 17.8333C9.875 17.8333 9.5 17.4583 9.5 17V9.5C9.5 9.04167 9.875 8.66667 10.3333 8.66667C10.7917 8.66667 11.1667 9.04167 11.1667 9.5ZM22 6.16667V17.8333C22 20.1333 20.1333 22 17.8333 22H6.16667C3.86667 22 2 20.1333 2 17.8333V6.16667C2 3.86667 3.86667 2 6.16667 2H17.8333C20.1333 2 22 3.86667 22 6.16667ZM20.3333 6.16667C20.3333 4.79167 19.2083 3.66667 17.8333 3.66667H6.16667C4.79167 3.66667 3.66667 4.79167 3.66667 6.16667V17.8333C3.66667 19.2083 4.79167 20.3333 6.16667 20.3333H17.8333C19.2083 20.3333 20.3333 19.2083 20.3333 17.8333V6.16667ZM7 11.1667C6.54167 11.1667 6.16667 11.5417 6.16667 12V17C6.16667 17.4583 6.54167 17.8333 7 17.8333C7.45833 17.8333 7.83333 17.4583 7.83333 17V12C7.83333 11.5417 7.45833 11.1667 7 11.1667ZM13.6667 6.16667C13.2083 6.16667 12.8333 6.54167 12.8333 7V17C12.8333 17.4583 13.2083 17.8333 13.6667 17.8333C14.125 17.8333 14.5 17.4583 14.5 17V7C14.5 6.54167 14.125 6.16667 13.6667 6.16667ZM17 13.6667C16.5417 13.6667 16.1667 14.0417 16.1667 14.5V17C16.1667 17.4583 16.5417 17.8333 17 17.8333C17.4583 17.8333 17.8333 17.4583 17.8333 17V14.5C17.8333 14.0417 17.4583 13.6667 17 13.6667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/Chart.b708e77659fa295da6efd9dc0b64ffa6.svg";
export { ForwardRef as ReactComponent };